const COOKIES = {
  COOKIE_POLICY: 'cookie_policy_accepted',
  TOS_PRIVACY: 'stockx_tos_privacy_accepted',
  IS_GDPR: 'is_gdpr',
};

export default COOKIES;
